import { useState, useRef, useEffect } from 'react';
import './CreateLeadModal.css';

const SOURCES = ['REFERRAL', 'EVENT', 'WALK_IN', 'COLD_CALL', 'DIGITAL', 'OTHER'];
const SOURCE_LABELS = {
  REFERRAL: 'Referral', EVENT: 'Event', WALK_IN: 'Walk-in',
  COLD_CALL: 'Cold call', DIGITAL: 'Digital', OTHER: 'Other'
};

const ENTRY_STAGES = [
  { status: 'NEW',               label: 'Just Discovered' },
  { status: 'CALLING',           label: 'Already Talking' },
  { status: 'ENGAGED',           label: 'Actively Engaged' },
  { status: 'MEETING_SCHEDULED', label: 'Meeting Lined Up' },
  { status: 'QUALIFIED',         label: 'Ready to Invest' },
];

export default function CreateLeadModal({ onClose, onCreated }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [source, setSource] = useState('');
  const [aumInput, setAumInput] = useState('');
  const [entryStatus, setEntryStatus] = useState('NEW');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const nameRef = useRef(null);

  useEffect(() => {
    if (nameRef.current) nameRef.current.focus();
  }, []);

  async function handleCreate() {
    if (!name.trim()) { setError('Name is required'); return; }
    if (!phone.trim()) { setError('Phone is required'); return; }
    setSaving(true);
    setError('');
    try {
      await onCreated({ name: name.trim(), phone: phone.trim(), source: source || undefined, initialStatus: entryStatus, estimatedAum: aumInput ? parseFloat(aumInput) * 100000 : undefined });
      onClose();
    } catch (ex) {
      setError(ex.message);
      setSaving(false);
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') handleCreate();
    if (e.key === 'Escape') onClose();
  }

  return (
    <div className="crm__overlay" onClick={onClose}>
      <div className="crm__modal" onClick={e => e.stopPropagation()} onKeyDown={handleKeyDown}>
        <div className="crm__header">
          <span className="crm__title">New Lead</span>
          <button className="crm__close" onClick={onClose}>×</button>
        </div>

        <div className="crm__body">
          {error && <div className="crm__error">{error}</div>}

          <div className="crm__field">
            <label className="crm__label">Name <span className="crm__req">*</span></label>
            <input
              ref={nameRef}
              className="crm__input"
              placeholder="Full name"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>

          <div className="crm__field">
            <label className="crm__label">Phone <span className="crm__req">*</span></label>
            <input
              className="crm__input"
              placeholder="Mobile number"
              value={phone}
              onChange={e => setPhone(e.target.value)}
            />
          </div>

          <div className="crm__field">
            <label className="crm__label">Source <span className="crm__optional">(optional)</span></label>
            <select className="crm__select" value={source} onChange={e => setSource(e.target.value)}>
              <option value="">— Select source —</option>
              {SOURCES.map(s => (
                <option key={s} value={s}>{SOURCE_LABELS[s]}</option>
              ))}
            </select>
          </div>

          <div className="crm__field">
            <label className="crm__label">Estimated AUM <span className="crm__optional">(optional — in Lakhs)</span></label>
            <div className="crm__aum-row">
              <span className="crm__aum-prefix">₹</span>
              <input
                className="crm__input crm__aum-input"
                type="number"
                min="0"
                step="0.5"
                placeholder="e.g. 50"
                value={aumInput}
                onChange={e => setAumInput(e.target.value)}
              />
              <span className="crm__aum-suffix">L</span>
            </div>
          </div>

          <div className="crm__field">
            <label className="crm__label">Where is this lead in their journey?</label>
            <div className="crm__entry-stages">
              {ENTRY_STAGES.map(stage => (
                <button
                  key={stage.status}
                  type="button"
                  className={`crm__stage-btn ${entryStatus === stage.status ? 'crm__stage-btn--active' : ''}`}
                  onClick={() => setEntryStatus(stage.status)}
                >
                  {stage.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="crm__footer">
          <button className="btn--outline" onClick={onClose}>Cancel</button>
          <button className="btn--primary" onClick={handleCreate} disabled={saving}>
            {saving ? 'Creating...' : 'Create Lead'}
          </button>
        </div>
      </div>
    </div>
  );
}
